window.Review = {
	add: function (form) {
		let action = form.attr('action'),
			data = form.serialize();

		$(form).find('.text-error').slideUp();

		$.post(action, data, function (data) {
			if (!data.error) {
				yaCounterReachGoal('comment-store');

				form.slideUp();
				$('#review-response').slideDown();
				$('.btn-form-add-review').hide();

				$('.review-empty-template').hide();
				$("#review").removeClass('no-reviews');
				if (data.view) {
					$('.reviews').show().prepend(data.view);
				}
			} else {
				if (data.errors.rate) {
					$(form).find('.text-error').text('Пожалуйста, укажите оценку').slideDown();
				}
			}
		});

		return false
	},

	addQuestion: function (form) {
		let action = form.attr('action'),
			data = form.serialize();

		$(form).find('.text-error').slideUp();

		$.post(action, data, function (data) {
			if (!data.error) {
				yaCounterReachGoal('comment-store-question');

				form.slideUp();
				$('#review-question-response').slideDown();
				$('.btn-form-add-review-question').hide();

				$('.review-empty-template').hide();
				$("#review").removeClass('no-reviews');
				if (data.view) {
					$('.reviews').show().prepend(data.view);
				}
			}
		});

		return false
	},

	like: function (id, elem) {
		$.post('/comments/'+id+'/like', {_token: App.csrf}, function (data) {
			yaCounterReachGoal('comment-like');
			$(elem).addClass('liked')
				.find('.likes').text(data.likes);

		});
	},

	dislike: function (id, elem) {
		$.post('/comments/'+id+'/dislike', {_token: App.csrf}, function (data) {
			yaCounterReachGoal('comment-dislike');
			$(elem).addClass('disliked')
				.find('.likes').text(data.likes);
		});
	},
};

$(document).ready(function () {
	$(document).on('submit', '#form-review', function () {
		Review.add($(this));
		return false;
	});
	$(document).on('submit', '#form-review-question', function () {
		Review.addQuestion($(this));
		return false;
	});
	$(document).on('click', '[data-review=like]', function () {
		Review.like(
			$(this).closest('.vg-reviews-item').data('id'),
			$(this).closest('.review-like')
		);
		return false;
	});
	$(document).on('click', '[data-review=dislike]', function () {
		Review.dislike(
			$(this).closest('.vg-reviews-item').data('id'),
			$(this).closest('.review-like')
		);
		return false;
	});
});